"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxStarts = ajaxStarts;
exports.ajaxEnded = ajaxEnded;

var _reduxUtils = require("@dealersocket/redux-utils");

var _setApiBusy = require("./actions/set-api-busy.action");

var apiBusyCount = 0;

function ajaxStarts() {
  if (apiBusyCount === 0) {
    _reduxUtils.storeHelper.dispatch((0, _setApiBusy.setApiBusyAction)(true));
  }

  apiBusyCount += 1;
}

function ajaxEnded() {
  apiBusyCount -= 1;

  if (apiBusyCount === 0) {
    _reduxUtils.storeHelper.dispatch((0, _setApiBusy.setApiBusyAction)(false));
  }
}